import { render, staticRenderFns } from "./codePopup.vue?vue&type=template&id=1b02466f&scoped=true"
import script from "./codePopup.vue?vue&type=script&lang=js"
export * from "./codePopup.vue?vue&type=script&lang=js"
import style0 from "./codePopup.vue?vue&type=style&index=0&id=1b02466f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b02466f",
  null
  
)

export default component.exports